import { getCategoryApiLabel } from '../../shared/categories';
import { getSubCategoryApiLabel } from '../../shared/subCategories';
import type {
	FormValues,
	PetitionReportContext,
	PetitionSupporterCommentReportContext,
	PetitionSupporterVideoReportContext,
	ReportContext,
} from '../../shared/types';
import { WIRE_REPORT_TYPE } from '../../shared/wireReportType';

import type { Report } from './api';
import type { Common } from './api/shared/types';

const petitionPayload = (context: PetitionReportContext, common: Common): Report => ({
	...common,
	type: WIRE_REPORT_TYPE.petition,
	petitionId: context.petitionId,
	petitionUrl: `/p/${context.petitionSlug}`,
});
const supporterCommentPayload = (context: PetitionSupporterCommentReportContext, common: Common): Report => ({
	...common,
	type: WIRE_REPORT_TYPE.petitionSupporterComment,
	commentId: context.contentId,
	petitionUrl: `/p/${context.petitionSlug}`,
	commentUrl: `/p/${context.petitionSlug}/c/${context.contentId}`,
});
const supporterVideoPayload = (context: PetitionSupporterVideoReportContext, common: Common): Report => ({
	...common,
	type: WIRE_REPORT_TYPE.petitionSupporterVideo,
	commentId: context.contentId,
	petitionUrl: `/p/${context.petitionSlug}`,
	commentUrl: `/p/${context.petitionSlug}/v/${context.contentId}`,
});

export function normalizeForApi(context: ReportContext, values: FormValues): Report {
	const category = values.category ? getCategoryApiLabel(context.type, values.category) : '';
	const subCategory = values.subCategory ? getSubCategoryApiLabel(context.type, values.subCategory) : category;
	const common: Common = {
		category,
		subCategory,
		reason: values.reason || '',
	};
	switch (context.type) {
		case 'petition':
			return petitionPayload(context, common);
		case 'petitionSupporterComment':
			return supporterCommentPayload(context, common);
		case 'petitionSupporterVideo':
			return supporterVideoPayload(context, common);
		case 'generic':
			return {
				type: 'generic',
				...common,
				pageUrl: context.pageUrl,
			};
		default:
			throw new Error('Unsupported report context type');
	}
}
